export const TABLE_COLUMNS_COUNT = 3
